<div class="NgxEditor__MenuItem--IconContainer" [class.NgxEditor--Disabled]="disabled" [innerHTML]="html | sanitizeHtml"
  (mousedown)="insert($event)" [title]="getTitle(name)">
</div>
